import { render, staticRenderFns } from "./DoctorForm.vue?vue&type=template&id=fdf66314&scoped=true"
import script from "./DoctorForm.vue?vue&type=script&lang=js"
export * from "./DoctorForm.vue?vue&type=script&lang=js"
import style0 from "./DoctorForm.vue?vue&type=style&index=0&id=fdf66314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf66314",
  null
  
)

export default component.exports